// extracted by mini-css-extract-plugin
export default {"recommendList":"EditReconmmend_recommendList__bC4E7","recommendListTitle":"EditReconmmend_recommendListTitle__yKlLL","recommendListItems":"EditReconmmend_recommendListItems__ZAhUN"};